import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { EditComponent } from '@app/common/templates/edit/edit.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
	templateUrl: '../../../../common/templates/edit/edit.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/edit/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblLeerungBarcodeStatusEditComponent extends EditComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public dialogService: DialogService,
		public globals: Globals,
		public messageService: MessageService,
		public router: Router,
		public translate: TranslateService,
	) {
		super(accountService, breadcrumbService, confirmationService, crudService, dialogService, globals, messageService, router, translate);

		this.apiUrl = 'TblLeerungBarcodeStatus';
		this.name = 'MENU.STATUSBARCODES';
		this.url = '/' + PATH.LEERUNG_BARCODE_STATUS;
		this.fieldgroups.push(
			[
				//{ type: 'numeric', key: 'nkey', required: true, width: 400 },
				{ type: 'text', key: 'ankey', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 400 },
				{ type: 'boolean', key: 'VIRTUAL_flag_ScannungErsetztLrgStatus', required: false, width: 400 },
				{ type: 'boolean', key: 'VIRTUAL_flag_ScannungIstAbrechnungsrelevant', required: false, width: 400 },
				{ type: 'boolean', key: 'VIRTUAL_flag_ScannungMehrfacheNichtLoeschen', required: false, width: 400 },
				{ type: 'boolean', key: 'VIRTUAL_flag_ScannungVerbergenInLrgListe', required: false, width: 400 },
				{ type: 'boolean', key: 'VIRTUAL_flag_ManuelleZuweisungMoeglich', required: false, width: 400 },
				{ type: 'boolean', key: 'VIRTUAL_flag_LoestSchuettungsstopp', required: false, width: 400 },
			]
		);
		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.EDIT', routerLink: [this.url + '/' + PATH.EDIT + '/' + this.id] }
		]);
	}
}
